import { useTranslation } from 'react-i18next'
import _ from 'lodash'

import { languageCodes } from 'locales/i18n'

export const useTranslate = (ns = 'translation') => {
  const { t, i18n } = useTranslation(ns, { useSuspense: false })

  const currentLanguage = i18n.language

  const getAnyLanguage = (value) => {
    for (let index = 0; index < languageCodes.length; index++) {
      const languageCode = languageCodes[index]
      if (value[languageCode]) return value[languageCode]
    }
  }

  const translateFromObject = (value) => {
    return value[currentLanguage] || getAnyLanguage(value)
  }

  return {
    t: (value, options) => {
      if (_.isObject(value)) {
        return translateFromObject(value)
      } else {
        return t(value, options)
      }
    },
  }
}
